import React from 'react';

import {
  Menu,
  MenuItem,
  MenuItemBody,
} from 'components/templates/menus/styles';

const VerificationListMenu = () => (
  <Menu>
    <MenuItem
      as="a"
      target="_blank"
      href="http://ameriburn.org/quality-care/verification/verification-process-burn-centers/"
      rel="noopener noreferrer"
      style={{ textDecoration: 'underline' }}
    >
      Burn Center Site Visit Instructions
    </MenuItem>
    <MenuItem
      as="a"
      href="mailto:verification@ameriburn.org"
      rel="noopener noreferrer"
      target="_blank"
    >
      <span>Questions?</span>
      <MenuItemBody style={{ textDecoration: 'underline' }}>
        Email verification@ameriburn.org
      </MenuItemBody>
    </MenuItem>
  </Menu>
);

export default VerificationListMenu;
